module.exports = {
  type: 'spa',
  isTenanted: false,
  publicPath: '/gb-tenant/',
  octopusPackageId: 'global-portal-tenant',
  octopusProjectName: 'Global Portal Tenant',
  mountDOMId: '__app__',
  standalone: false,
  frameless: true
};